import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { BlogRollComponent, FiveReasonsToComponent, FiveTrendsShapingComponent, SuperSizedShippingComponent, GlassHalfFullComponent, WalmartAmazonTakeComponent, AnalyticsAnswerYourBusinessQuestions, SampleNewsComponent } from './';

const blogRoutes: Routes = [
  {
    path: '',
    component: BlogRollComponent
  },
  {
    path: '',
    children: [
      { path: '2017-2-6-five-reasons-to-use-scheduling-data', component: FiveReasonsToComponent },
      { path: 'sample-news', component: SampleNewsComponent },
      { path: '2017-1-30-five-trends-shaping-thee-global-maritime-industry', component: FiveTrendsShapingComponent },
      { path: '2017-1-23-walmart-amazon-take-retail-shipping-wars-to-sea', component: WalmartAmazonTakeComponent },
      { path: '2017-3-16-glass-half-full-in-shippings-murky-waters', component: GlassHalfFullComponent },
      { path: '2017-8-21-five-outcomes-of-super-sizing-shipping-industry', component: SuperSizedShippingComponent },
      { path: '2018-3-5-analytics-answer-your-questions', component: AnalyticsAnswerYourBusinessQuestions }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(blogRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class BlogRoutingModule { }



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/blog/blog-routing.module.ts